<!-- TelcoTrack - Input Component Template -->
<div [class]="containerClasses">
  
  <!-- Label -->
  <label *ngIf="label" class="label-normal mb-1 block">
    {{ label }}
    <span *ngIf="required" class="text-error ml-1">*</span>
  </label>

  <!-- Input container -->
  <div class="relative">
    
    <!-- Left icon -->
    <div *ngIf="leftIcon" class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
      <i [class]="'icon ' + leftIcon" class="w-5 h-5 text-tertiary"></i>
    </div>

    <!-- Input field -->
    <input
      [type]="type"
      [value]="value"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="readonly"
      [required]="required"
      [autocomplete]="autocomplete"
      [attr.maxlength]="maxlength || null"
      [attr.minlength]="minlength || null"
      [pattern]="pattern"
      [class]="inputClasses"
      (input)="onInputChange($event)"
      (focus)="onInputFocus($event)"
      (blur)="onInputBlur($event)"
    />

    <!-- Right icon -->
    <div *ngIf="rightIcon" class="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
      <i [class]="'icon ' + rightIcon" class="w-5 h-5 text-tertiary"></i>
    </div>

  </div>

  <!-- Helper text -->
  <p *ngIf="helperText && !errorMessage" class="caption text-tertiary mt-1">
    {{ helperText }}
  </p>

  <!-- Error message -->
  <p *ngIf="errorMessage" class="caption text-error mt-1">
    {{ errorMessage }}
  </p>

</div>
